import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import i18next from '../i18next';

dayjs.extend(relativeTime);

interface FormatTimestampOptions {
  useRelativeTimeForMonth?: boolean;
}

export const formatTimestamp = (
  date: string | Date,
  options: FormatTimestampOptions = {}
): string => {
  const { useRelativeTimeForMonth = false } = options;
  const messageDate = dayjs(date);
  const now = dayjs();
  const oneHour = 60 * 60 * 1000;

  if (Math.abs(now.diff(messageDate)) <= oneHour)
    return i18next.t('label.recent');

  const timeUnit = useRelativeTimeForMonth ? 'month' : 'day';
  if (messageDate.isSame(now, timeUnit)) return messageDate.fromNow();

  return messageDate.format('YYYY-MM-DD');
};
